import React from 'react';
import ProductEnquiry from '../../../../../components/page/ProductEnquiry/ProductEnquiry';

export default function ProductEnquiriesVendor() {
	return (
		<>
			<ProductEnquiry />
		</>
	);
}
